/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
    ContactToJSONTyped,
} from './Contact';

/**
 * 
 * @export
 * @interface RelatedEntity
 */
export interface RelatedEntity {
    /**
     * 
     */
    type_code?: string;
    /**
     * 
     */
    type_code_definition?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_or_org_name?: string;
    /**
     * 
     */
    address?: Address;
    /**
     * 
     */
    provider_identifier_code_definition?: string;
    /**
     * 
     */
    provider_identifier?: string;
    /**
     * 
     */
    contacts?: Array<Contact>;
}

/**
 * Check if a given object implements the RelatedEntity interface.
 */
export function instanceOfRelatedEntity(value: object): value is RelatedEntity {
    return true;
}

export function RelatedEntityFromJSON(json: any): RelatedEntity {
    return RelatedEntityFromJSONTyped(json, false);
}

export function RelatedEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelatedEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'type_code': json['type_code'] == null ? undefined : json['type_code'],
        'type_code_definition': json['type_code_definition'] == null ? undefined : json['type_code_definition'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_or_org_name': json['last_or_org_name'] == null ? undefined : json['last_or_org_name'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'provider_identifier_code_definition': json['provider_identifier_code_definition'] == null ? undefined : json['provider_identifier_code_definition'],
        'provider_identifier': json['provider_identifier'] == null ? undefined : json['provider_identifier'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(ContactFromJSON)),
    };
}

export function RelatedEntityToJSON(json: any): RelatedEntity {
    return RelatedEntityToJSONTyped(json, false);
}

export function RelatedEntityToJSONTyped(value?: RelatedEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type_code': value['type_code'],
        'type_code_definition': value['type_code_definition'],
        'first_name': value['first_name'],
        'last_or_org_name': value['last_or_org_name'],
        'address': AddressToJSON(value['address']),
        'provider_identifier_code_definition': value['provider_identifier_code_definition'],
        'provider_identifier': value['provider_identifier'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(ContactToJSON)),
    };
}

